import React from "react";
import LandingPage from "./pages/landingpage";
import "./App.css";

const App = () => {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
};

export default App;
